import { FormGroup } from '@angular/forms';

export function DueDateValidator(due_date: string, first_due_date: string,maturity_date: string='maturity_date',type: string='',npDate?:string, numberOfYearLimit?:number) {
    return (formGroup: FormGroup) => {
        const firstDueDateFormControl = formGroup.controls[first_due_date];
        const dueDateFormControl = formGroup.controls[due_date];
        // const maturityDateFormControl = formGroup.controls[maturity_date];
        const typeFormControl = formGroup.controls[type];

        let dueDate = dueDateFormControl?.value;
        let firstDueDate = firstDueDateFormControl?.value;
        // let maturityDate = maturityDateFormControl?.value;
        let typeValue = typeFormControl?.value;
        let npDateValue:any = formGroup?.controls?.[npDate||'']?.value;

        if(dueDate) {

            if(numberOfYearLimit){
                const year = parseInt(dueDate.split('-')[0], 10);

                let date = new Date();
                let currentYear = date.getFullYear();
                const maxAllowedYear = currentYear + numberOfYearLimit;
                if (year > maxAllowedYear) {
                    const maxDate = `12/31/${maxAllowedYear}`;
                    dueDateFormControl.setErrors({
                        max_year_limit_exceeded: maxDate
                    });
                    return;
                }
            }

            // As per client request on 31-01-25 we are removing firstDueDate date validation from cpi due date
        
            if (((typeValue && typeValue == 'SIDE_NOTE') || !typeValue) && firstDueDate && firstDueDate > dueDate) {

                dueDateFormControl.setErrors({invalid_first_due_date_before_due_date: true });

                // dueDateFormControl.markAsTouched();

            }

            else if(npDateValue && firstDueDate && npDateValue<firstDueDate && firstDueDate!=dueDate){

                dueDateFormControl.setErrors({invalid_FDD_equal_DD: true });
            }
            // As per client request on 26-01-25 we are removing maturity date validation from side notes due date

            // else if (maturityDate && maturityDate <= dueDate ) {

            //     dueDateFormControl.setErrors({invalid_maturity_date_before_due_date: true });

            //     dueDateFormControl.markAsTouched();

            // }

            else
                dueDateFormControl.setErrors(null);
        }
        else {
            dueDateFormControl.setErrors({required:true});
        }
    }
}